import React from 'react';
import { useTranslation } from 'react-i18next';
import { Control, Controller, FieldErrors } from 'react-hook-form';
import FormField from '../common/FormField';
import InputField from '../common/InputField';
import Modal from '../common/Modal';
import ModalFooter from '../common/ModalFooter';
import TextArea from '../common/TextArea';

type TypeFormValues = {
  name: string;
  remarks: string;
};

interface EditLubricantTypeModalProps {
  onClose: () => void;
  onSubmit: () => void;
  control: Control<TypeFormValues>;
  errors?: FieldErrors<TypeFormValues>;
  isEditMode?: boolean;
  isSubmitting?: boolean;
}

const EditLubricantTypeModal: React.FC<EditLubricantTypeModalProps> = ({
  onClose,
  onSubmit,
  control,
  errors,
  isEditMode = false,
  isSubmitting = false,
}) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={true}
      onClose={onClose}
      title={isEditMode ? t('lubricants.editTypeTitle') : t('lubricants.addTypeTitle')}
      size="sm"
      footer={
        <ModalFooter
          onCancel={onClose}
          onSubmit={onSubmit}
          isLoading={isSubmitting}
          submitText={
            isSubmitting
              ? isEditMode
                ? t('buttons.updating')
                : t('buttons.adding')
              : isEditMode
                ? t('buttons.update')
                : t('buttons.add')
          }
        />
      }
    >
      <FormField label={t('form.typeName')} sx={{ mt: 2 }} required>
        <Controller
          name="name"
          control={control}
          rules={{ required: t('form.validation.typeNameRequired') }}
          render={({ field }) => (
            <InputField
              {...field}
              value={field.value || ''}
              placeholder={t('form.enterTypeName')}
              error={!!errors?.name}
              helperText={errors?.name?.message as string}
            />
          )}
        />
      </FormField>

      <FormField label={t('form.remarks')} sx={{ mt: 2 }}>
        <Controller
          name="remarks"
          control={control}
          render={({ field }) => (
            <TextArea
              {...field}
              value={field.value || ''}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder={t('form.enterRemarks')}
              rows={3}
            />
          )}
        />
      </FormField>
    </Modal>
  );
};

export default EditLubricantTypeModal;
